import {Component, inject, OnInit, Renderer2, signal, ViewChild} from '@angular/core';
import {TableComponent, TableOptions} from '@shared/components';
import {Allergy} from '@core/classes/tables/allergy';
import {APIService} from '@core/services';
import {HttpHeaders, HttpParams} from '@angular/common/http';
import {PatientSession} from '@core/classes/other/patient-session';
import {PatientService} from '@core/services/patient.service';
import {NavigationEnd, Router} from '@angular/router';
import {
  AllergyStatusActionComponent
} from '@modules/cy/patient/ps/components/allergies/actions/allergy-status-action/allergy-status-action.component';
import {Medication} from '@core/classes/tables/medication';
import {
  AddAllergyComponent
} from '@modules/cy/patient/ps/components/allergies/actions/add-allergy/add-allergy.component';
import {
  AllergyUnknownValuesComponent
} from '@modules/cy/patient/ps/components/allergies/actions/allergy-unknown-values/allergy-unknown-values.component';
import {Subject, takeUntil} from 'rxjs';

@Component({
  selector: 'ncp-allergies',
  imports: [
    TableComponent
  ],
  templateUrl: './allergies.component.html',
  styleUrl: './allergies.component.scss',
})
export class AllergiesComponent implements OnInit {
  @ViewChild('allergies') public allergiesEl!: TableComponent<Allergy>;
  protected readonly router = inject(Router);
  protected readonly apiService = inject(APIService);
  protected readonly patientService = inject(PatientService);
  protected renderer2 = inject(Renderer2);

  private subscription: any;
  private destroy$ = new Subject<void>();

  protected options = signal<TableOptions<Allergy>>(
    new TableOptions<Allergy>({
      id: 'allergies',
      type: 'Allergies',
      interface: Allergy,
      autoLoadData: false,
      ignoreColumns: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit')? [] : ['status'],
      pagination: {
        itemsPerPage: 10,
        pageNumber: 1,
        totalItems: 0,
      },
      searchComponent: null,
    })
  );

  ngOnInit(): void {
    this.getData(
      (this.router.url === '/cy/patient/ps/edit' || this.router.url === '/cy/patient/ps/create') ? -1 : 0,
      (this.router.url === '/cy/patient/ps/edit' || this.router.url === '/cy/patient/ps/create') ? -1 : 0
    );

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.subscription) {
          this.subscription.unsubscribe();
        }
      }
    });
  }

  protected getData = (mode: number = 0, status: number = 0) => {
    this.subscription = this.apiService
      .call({
        path: '/get-allergies',
        headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
        body: {
          mode: mode,
          status: status,
          version_id: this.patientService.patient?.version?.id || -1
        }
      })?.pipe(takeUntil(this.destroy$)).subscribe((response: any) => {
      if(response && response.status === 1) {
        this.options.set(
          new TableOptions<Allergy>({
            id: 'allergies',
            type: 'Allergies',
            interface: Allergy,
            data: response.data,
            autoLoadData: false,
            ignoreColumns: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit') ? [] : ['status'],
            actionsComponent: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit') ? AllergyStatusActionComponent : undefined,
            extraComponent: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit') ? AddAllergyComponent : undefined,
            extraLeftComponent: AllergyUnknownValuesComponent,
            pagination: {
              itemsPerPage: 10,
              pageNumber: 1,
              totalItems: response.data.length,
            },
            otherData: response.unknown,
            renderCustomRow: (td: HTMLTableCellElement, row: {}, item: string) => {
              const data = row as Allergy;
              if (item === 'status') {
                td.innerHTML = '';

                let iEl = this.renderer2.createElement('h2');
                if(data.status === 1) {
                  this.renderer2.addClass(iEl, 'bi');
                  this.renderer2.addClass(iEl, 'bi-eye');
                  this.renderer2.addClass(iEl, 'text-primary');
                } else {
                  this.renderer2.addClass(iEl, 'bi');
                  this.renderer2.addClass(iEl, 'bi-eye-slash');
                  this.renderer2.addClass(iEl, 'text-secondary');
                }
                this.renderer2.appendChild(td, iEl);
              }
            },
            searchComponent: null,
          })
        );
      }
    })
  }

}
